import type { DashboardPayload, SignalItem } from "../types";

const SIGNAL_SEVERITY_MARK: Record<SignalItem["severity"], string> = {
  alert: "▲",
  watch: "●",
  good: "▲",
};

const SIGNAL_SEVERITY_CLASS: Record<SignalItem["severity"], string> = {
  alert: "signal-row--alert",
  watch: "signal-row--watch",
  good: "signal-row--good",
};

function SignalsPanel({ signals }: { signals: DashboardPayload["signals"] }) {
  const items = signals.items.slice(0, 5);

  return (
    <section className="signals-panel" aria-label="今月のシグナル">
      {items.length === 0 ? (
        <p className="signals-panel__empty">特筆すべきシグナルはありません。</p>
      ) : (
        <ul className="signals-panel__list">
          {items.map((item) => (
            <li key={item.id} className={`signal-row ${SIGNAL_SEVERITY_CLASS[item.severity]}`}>
              <a className="signal-row__link" href={`#${item.indicatorId}`}>
                <span className="signal-row__mark" aria-hidden="true">
                  {SIGNAL_SEVERITY_MARK[item.severity]}
                </span>
                <span className="signal-row__title">{item.title}</span>
                <span className="signal-row__detail">{item.detail}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export { SignalsPanel, SIGNAL_SEVERITY_MARK, SIGNAL_SEVERITY_CLASS };
